// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_ip-6";
export var emphasizeQuantity = "_ip-3";
export var flatBottomCorners = "_ip-5";
export var productImage = "_ip-0";
export var quantityContainer = "_ip-2";
export var tooltip = "_ip-1";
export var wrapAndEllipsesOverflow = "_ip-4";